import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import blankBackground from '../../../assets/Blank.svg';
import blankDarkBackground from '../../../assets/Blank-dark.svg';
import { Box } from '@mui/material';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
   root: {
      flexGrow: 1,
      justifyContent: 'center',
   },
}));

const BlankBlock = (props) => {
   const classes = useStyles();
   const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

   return (
      <div className={classes.root}>
         <Box
            sx={{
               width: '100%',
               height: '70vh',
               backgroundImage: `url(${
                  prefersDarkMode ? blankDarkBackground : blankBackground
               })`,
               backgroundRepeat: 'no-repeat',
               backgroundPosition: 'center',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               mt: 6,
            }}
         ></Box>
      </div>
   );
};

export default BlankBlock;
